<template src="./verHistoriaClinica.html"></template>
<script>
import VerListadoEncuentros from "../VerListadoEncuentros/VerListadoEncuentros";
import VerEncuentrosExistentes from "../VerEncuentrosExistentes/VerEncuentrosExistentes";
import VerSeguimientoPaciente from "../Seguimiento/VerSeguimientoPaciente/VerSeguimientoPaciente";
import { serverBus } from "../../main";
import Icono from "../Icono/Icono";
export default {
  data() {
    return {
      deshabilitado: true,
      verComponente: "",
      iconoVolver:
        "M33,44c-0.3,0-0.5-0.1-0.7-0.3l-22-21C10.1,22.5,10,22.3,10,22s0.1-0.5,0.3-0.7l22-21C32.6,0,33-0.1,33.4,0.1 C33.8,0.2,34,0.6,34,1v42c0,0.4-0.2,0.8-0.6,0.9C33.3,44,33.1,44,33,44z M12.4,22L32,40.7V3.3L12.4,22z M44,0v44 M0,0v44"
    };
  },
  mounted() {
    serverBus.$on(
      "abrirTarjetaFormularioOverlay",
      (id, nombreCategoria, valor, coleccion) => {
        console.log(
          "clickTarjetaMiniatura",
          id,
          nombreCategoria,
          valor,
          coleccion
        );
        this.verComponente = coleccion;
        this.$store.dispatch("setColeccionOverlay", coleccion);
        if (coleccion == "encuentros") {
          this.$store.dispatch("setConsultarEncuentroOverlay", nombreCategoria);
          this.$store.dispatch("setEncuentroOverlay", nombreCategoria);
          this.$store.dispatch("setIdVerEncuentrosOSeguimiento", id);
        } else if (coleccion == "seguimientos") {
          this.$store.dispatch("setNombreEventoOverlay", nombreCategoria);
        }

        this.$store.dispatch("setIdVerEncuentrosOSeguimiento", id);
      }
    );
  },
  beforeDestroy() {
    serverBus.$off("abrirTarjetaFormularioOverlay");
  },
  created() {
    this.$store.dispatch("setIdVerEncuentrosOSeguimiento", null);
  },
  props: {
    banderaSubirArchivo: {
      type: Boolean,
      default: true
    }
  },
  components: {
    VerListadoEncuentros,
    VerEncuentrosExistentes,
    VerSeguimientoPaciente,
    Icono
  },
  methods: {
    volverHC() {
      this.verComponente = "";
      this.$store.dispatch("setIdVerEncuentrosOSeguimiento", null);
      this.$store.dispatch("setVariablesFormulariosOverlay", null);
      this.$emit("volverHC");
    }
  }
};
</script>
<style lang="scss" scoped src="./verHistoriaClinica.scss">

</style>


// WEBPACK FOOTER //
// src/components/verHistoriaClinica/verHistoriaClinica.vue